<template>
    <div class="all-box">
        <div>
            <PostureReportView :resultData="resultData" v-if="apiLoaded" />
            <BodyComponentReportView :resultData="resultData" v-if="apiLoaded && resultData.bodyResult" :historyData="historyData" />
            <!-- <FunctionalEvaluationView :resultData="resultData" v-if="apiLoaded" /> -->
        </div>
    </div>
</template>
<script>
import print from "print-js";
import PostureReportView from "@/views/PostureReportView.vue";
import BodyComponentReportView from "@/views/BodyComponentReportView.vue";
import FunctionalEvaluationView from "@/components/FunctionalEvaluationView.vue";
import axios from 'axios';
export default {

    components: {
        PostureReportView,
        BodyComponentReportView,
        FunctionalEvaluationView
    },
    mounted() {
        this.applyScale();
        window.addEventListener('resize', this.applyScale);
    },

    data() {
        return {
            resultData: "",
            apiLoaded: false,
            historyData: "",
            recordId: "",
            printObj: {
                id: "printBill", //要打印的id名 无#号
                popTitle: "&nbsp;", //页眉标题 默认浏览器标题 空字符串时显示undefined 使用html语言
                extraHead: "",
                previewBeforeOpenCallback: () => {
                    console.log("触发打印预览打开前回调");
                },
                previewOpenCallback: () => {
                    console.log("触发打开打印预览回调");
                },
                beforeOpenCallback: () => {
                    console.log("触发打印工具打开前回调");
                },
                openCallback: () => {
                    console.log("触发打开打印工具回调");
                },
                closeCallback: () => {
                    console.log("触发关闭打印工具回调，");
                    const { mes_ids } = this.$route.query;
                    if (mes_ids) {
                        this.printInfo(mes_ids);
                    }
                    this.time = getNowDate();
                },
                clickMounted: () => {
                    console.log("触发点击打印回调");
                },
            },
        }
    },
    created() {
        //通过地址栏后去参数
        this.recordId = this.$route.query.recordId
        this.requestData()
    },
    methods: {
        isMobileDevice() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // 检查用户代理字符串是否包含常见的移动设备标识
            return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
        },
        applyScale() {
            const isMobile = this.isMobileDevice() && window.innerWidth < 600; // 同时检查用户代理和窗口宽度
            if (isMobile) {
                document.body.classList.add('mobile');
                document.documentElement.style.height = 'calc(100% * 0.35)';
            } else {
                document.body.classList.remove('mobile');
                document.documentElement.style.height = '100%';
            }
        },
        requestData() {
            let params = {
                "recordId": this.recordId,

            }
            const request1 = this.$http.reqM1Service(this.$API_URL.queryUserPhysicalRecordDetail, params, 'POST');
            const request2 = this.$http.reqM1Service(this.$API_URL.queryUserPhysicalBodyHistory, params, 'POST')
            axios.all([request1, request2])
                .then(axios.spread((response1, response2) => {
                    console.log("--------登录-------", response1)
                    console.log("--------历史-------", response2)
                    if (response1.code == "0000000") {
                        document.title = response1.data.name+'的报告';
                        //这里需要存需要的返回参数
                        this.apiLoaded = true
                        this.resultData = response1.data
                        // this.resultData.bodyResult = ""
                        this.imageSrc = response1.data.fileUrlOne
                        this.historyData = response2.data
                    }
                }))
                .catch(error => {
                    this.error = error;
                });
        }
    }
}
</script>


<style scoped>
/* 打印 */
@media print {

    html,
    body {
        width: 210mm;
        height: 297mm;
        margin: 0;
        padding: 0;
    }

}

/* 根DIV */
.all-box {
    width: 1100px;
    margin: 0 auto;
    font-family: PingFangSC, PingFang SC;
    background-color: #ffffff;
}
</style>